var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L15 15L10 20",
    stroke: "#10B981",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15V26.25",
    stroke: "#10B981",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4864 22.9883C26.7055 22.3237 27.6686 21.2719 28.2237 19.9991C28.7787 18.7263 28.8941 17.3049 28.5516 15.9592C28.2091 14.6135 27.4282 13.4202 26.3322 12.5676C25.2362 11.7151 23.8874 11.2518 22.4989 11.2508H20.9239C20.5455 9.78739 19.8403 8.42875 18.8613 7.27708C17.8823 6.1254 16.6549 5.21065 15.2715 4.60159C13.888 3.99254 12.3845 3.70503 10.874 3.76069C9.36346 3.81634 7.88519 4.21371 6.55032 4.92292C5.21546 5.63212 4.05874 6.63471 3.16713 7.85531C2.27552 9.07591 1.67221 10.4828 1.40258 11.9701C1.13294 13.4574 1.20398 14.9865 1.61037 16.4424C2.01675 17.8983 2.7479 19.2432 3.74885 20.3758",
    stroke: "#10B981",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L15 15L10 20",
    stroke: "#10B981",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3e1795cf85338db883adf2669b24ac5b.svg";
export { ForwardRef as ReactComponent };